import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';
import AuthDropdown from '../../AuthDropdown';

const ActionArea = ({
  isAuthenticated,
  user,
  login,
  signup
}) => {
  let authSection;

  if (isAuthenticated) {
    authSection = <AuthDropdown {...user.profile} />;
  } else {
    authSection = (
      <React.Fragment>
        <button className="login-link btn btn-transparent btn-sm" onClick={login}>Login</button>
        <button className="login-button btn btn-success btn-sm" onClick={signup}>Sign up</button>
      </React.Fragment>
    );
  }

  return (
    <div className={styles.actions}>
      <a href="https://auth0.com/get-started?place=header&type=button&text=talk%20to%20sales" className={`${styles.talkToSales} btn btn-transparent btn-sml`}>
        Talk to Sales
      </a>

      {authSection}
    </div>
  );
};

ActionArea.propTypes = {
  login: PropTypes.func.isRequired,
  signup: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  user: PropTypes.object
};

export default ActionArea;
